// Este codigo fue generado por Github Copilot Chat
import { Pipe, PipeTransform } from '@angular/core';
import { Collaborator } from '../helpers/collaborator.model';

@Pipe({
  name: 'collaborators',
  standalone: true
})
export class CollaboratorsPipe implements PipeTransform {
  transform(value: unknown): Collaborator[] {
    if (!value) {
      return [];
    }

    // Si ya es un array de colaboradores, lo devolvemos tal como está
    if (Array.isArray(value)) {
      return value as Collaborator[];
    }

    // Si es un string separado por comas, lo convertimos
    if (typeof value === 'string') {
      return value.split(',').map((name) => ({
        name: name.trim(),
        lastName: '',
        usernameSura: '',
        document: '',
        documentType: '',
        email: ''
      }));
    }

    // Si es un objeto único, lo convertimos a array
    if (typeof value === 'object') {
      return [value as Collaborator];
    }

    return [];
  }
}
// Este codigo fue generado por Github Copilot Chat
